// extracted by mini-css-extract-plugin
export default {"mapPin":"MapPin_mapPin__WoG8Z","mapPinText":"MapPin_mapPinText__oPvpE","arrowDown":"MapPin_arrowDown__AM44a"};